import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Eye, Mail, MessageSquare } from 'lucide-react';
import { Button } from '../../components/ui/Button';
export function ChristmasPalace() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="w-full pt-24 pb-24 bg-engage-black min-h-screen" data-id="element-123">
      <div className="max-w-6xl mx-auto px-4" data-id="element-124">
        {/* Back Link */}
        <Link to="/case-studies" className="inline-flex items-center text-engage-gray4 hover:text-engage-yellow transition-colors mb-12 font-medium" data-id="element-125">
          <ArrowLeft className="w-4 h-4 mr-2" data-id="element-126" />
          Back to Case Studies
        </Link>

        {/* Hero */}
        <div className="mb-16 max-w-4xl" data-id="element-127">
          <div className="flex flex-wrap gap-3 mb-6" data-id="element-128">
            <span className="px-4 py-1.5 bg-engage-yellow/10 text-engage-yellow border border-engage-yellow/20 rounded-full text-sm font-bold uppercase tracking-wider" data-id="element-129">
              E-Commerce Growth
            </span>
            <span className="px-4 py-1.5 bg-engage-gray2 text-engage-gray5 rounded-full text-sm font-bold uppercase tracking-wider" data-id="element-130">
              Multi-Channel Scaling
            </span>
            <span className="px-4 py-1.5 bg-engage-gray2 text-engage-gray5 rounded-full text-sm font-bold uppercase tracking-wider" data-id="element-131">
              Email + SMS Monetization
            </span>
          </div>
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-black text-engage-white tracking-tight mb-4" data-id="element-132">
            The Christmas Palace
          </h1>
          <h2 className="text-2xl md:text-3xl text-engage-gray4 font-medium leading-tight" data-id="element-133">
            Turning Content into Holiday Demand at Scale
          </h2>
        </div>

        {/* Key Results Stats */}
        <div className="mb-16" data-id="element-134">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-135">
            <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 relative overflow-hidden group hover:border-engage-yellow/50 transition-colors" data-id="element-136">
              <div className="absolute top-0 right-0 p-6 opacity-5 group-hover:opacity-10 transition-opacity" data-id="element-137">
                <Eye className="w-24 h-24 text-engage-yellow" data-id="element-138" />
              </div>
              <div className="relative z-10 flex flex-col h-full justify-between" data-id="element-139">
                <div className="w-12 h-12 bg-engage-black border border-engage-gray2 rounded-xl flex items-center justify-center mb-6" data-id="element-140">
                  <Eye className="w-6 h-6 text-engage-yellow" data-id="element-141" />
                </div>
                <div data-id="element-142">
                  <div className="text-4xl md:text-5xl font-black text-engage-white mb-2 tracking-tight" data-id="element-143">
                    8M+ Views
                  </div>
                  <div className="text-engage-gray4 font-medium uppercase tracking-wider text-sm" data-id="element-144">
                    Organic reach generated
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 relative overflow-hidden group hover:border-engage-yellow/50 transition-colors" data-id="element-145">
              <div className="absolute top-0 right-0 p-6 opacity-5 group-hover:opacity-10 transition-opacity" data-id="element-146">
                <Mail className="w-24 h-24 text-engage-yellow" data-id="element-147" />
              </div>
              <div className="relative z-10 flex flex-col h-full justify-between" data-id="element-148">
                <div className="w-12 h-12 bg-engage-black border border-engage-gray2 rounded-xl flex items-center justify-center mb-6" data-id="element-149">
                  <Mail className="w-6 h-6 text-engage-yellow" data-id="element-150" />
                </div>
                <div data-id="element-151">
                  <div className="text-4xl md:text-5xl font-black text-engage-white mb-2 tracking-tight" data-id="element-152">
                    +102%
                  </div>
                  <div className="text-engage-gray4 font-medium uppercase tracking-wider text-sm" data-id="element-153">
                    Email Revenue Growth
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 relative overflow-hidden group hover:border-engage-yellow/50 transition-colors" data-id="element-154">
              <div className="absolute top-0 right-0 p-6 opacity-5 group-hover:opacity-10 transition-opacity" data-id="element-155">
                <MessageSquare className="w-24 h-24 text-engage-yellow" data-id="element-156" />
              </div>
              <div className="relative z-10 flex flex-col h-full justify-between" data-id="element-157">
                <div className="w-12 h-12 bg-engage-black border border-engage-gray2 rounded-xl flex items-center justify-center mb-6" data-id="element-158">
                  <MessageSquare className="w-6 h-6 text-engage-yellow" data-id="element-159" />
                </div>
                <div data-id="element-160">
                  <div className="text-4xl md:text-5xl font-black text-engage-white mb-2 tracking-tight" data-id="element-161">
                    +1,919%
                  </div>
                  <div className="text-engage-gray4 font-medium uppercase tracking-wider text-sm" data-id="element-162">
                    SMS Growth
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Content Sections */}
        <div className="space-y-10" data-id="element-163">
          {/* The Challenge */}
          <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 md:p-12" data-id="element-164">
            <h3 className="text-2xl md:text-3xl font-bold text-engage-white mb-3" data-id="element-165">
              The Challenge
            </h3>
            <div className="w-16 h-1 bg-engage-yellow rounded-full mb-6" data-id="element-166" />
            <p className="text-engage-gray4 text-base md:text-lg leading-relaxed" data-id="element-167">
              The Christmas Palace had a powerful in-store experience, but its
              digital presence didn{'\u2019'}t reflect that same level of
              impact. During peak season{'\u2014'}when attention is everything
              {'\u2014'}the brand lacked a content system capable of capturing
              demand at scale and translating it into store visits. With a short
              revenue window and fast-moving platforms, every piece of content
              needed to perform quickly or risk losing momentum.
            </p>
          </div>

          {/* Our Approach & The Result */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-168">
            <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 md:p-10 relative overflow-hidden" data-id="element-169">
              <div className="absolute top-0 right-0 w-40 h-40 bg-[radial-gradient(circle_at_top_right,rgba(252,198,13,0.12)_0%,transparent_70%)]" data-id="element-170" />
              <div className="relative z-10" data-id="element-171">
                <h3 className="text-2xl md:text-3xl font-bold text-engage-white mb-3" data-id="element-172">
                  Our Approach
                </h3>
                <div className="w-16 h-1 bg-engage-yellow rounded-full mb-6" data-id="element-173" />
                <p className="text-engage-gray4 text-base md:text-lg leading-relaxed" data-id="element-174">
                  We built a content-first growth engine designed for speed,
                  volume, and emotional impact. By producing platform-native
                  short-form videos and leveraging a high-volume testing
                  strategy, we allowed performance to dictate scale. Each piece
                  of content was crafted to capture attention instantly while
                  reinforcing the immersive, emotional experience of the brand
                  {'\u2014'}creating a loop where content drove traffic, and
                  in-store moments fueled more content.
                </p>
              </div>
            </div>
            <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 md:p-10 relative overflow-hidden" data-id="element-175">
              <div className="absolute top-0 right-0 w-40 h-40 bg-[radial-gradient(circle_at_top_right,rgba(252,198,13,0.12)_0%,transparent_70%)]" data-id="element-176" />
              <div className="relative z-10" data-id="element-177">
                <h3 className="text-2xl md:text-3xl font-bold text-engage-white mb-3" data-id="element-178">
                  The Result
                </h3>
                <div className="w-16 h-1 bg-engage-yellow rounded-full mb-6" data-id="element-179" />
                <p className="text-engage-gray4 text-base md:text-lg leading-relaxed" data-id="element-180">
                  In just 90 days, the brand became highly visible across social
                  platforms, generating over 8 million views and positioning
                  itself as a must-visit holiday destination. Content translated
                  directly into increased foot traffic and stronger sales
                  momentum, turning organic reach into real-world demand. What
                  started as a visibility effort became a scalable engine
                  driving both attention and revenue during the most critical
                  season.
                </p>
              </div>
            </div>
          </div>

          {/* Testimonial */}
          <div className="bg-engage-gray1 border border-engage-gray2 p-10 md:p-16 lg:p-20 rounded-2xl relative overflow-hidden text-center" data-id="element-181">
            <div className="flex justify-center mb-8" data-id="element-182">
              <svg width="40" height="40" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" className="text-engage-yellow" data-id="element-183">
                <path d="M14.017 21L16.411 14.182C16.411 14.182 15.045 14.182 15.045 10.773C15.045 7.36364 18.006 5 21 5C23.994 5 24 7.36364 24 7.36364C24 7.36364 22.634 7.36364 22.634 10.773C22.634 14.182 19.909 21 19.909 21H14.017ZM3.017 21L5.411 14.182C5.411 14.182 4.045 14.182 4.045 10.773C4.045 7.36364 7.006 5 10 5C12.994 5 13 7.36364 13 7.36364C13 7.36364 11.634 7.36364 11.634 10.773C11.634 14.182 8.909 21 8.909 21H3.017Z" data-id="element-184" />
              </svg>
            </div>
            <blockquote className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-medium italic text-engage-white mb-10 md:mb-12 leading-relaxed relative z-10 max-w-4xl mx-auto" data-id="element-185">
              We didn{'\u2019'}t just create content{'\u2014'}we created demand.
              The store became something people wanted to experience before even
              arriving.
            </blockquote>
            <div className="flex flex-col items-center relative z-10" data-id="element-186">
              <img src="https://cdn.magicpatterns.com/uploads/2rZSGAWtGvFRDAikqTV9Zd/The_Christmas_Palace-CS.png" alt="The Christmas Palace" className="w-16 h-16 md:w-20 md:h-20 rounded-full mb-4 border-2 border-engage-gray2 object-cover" data-id="element-187" />
              <div className="font-bold text-engage-white text-lg" data-id="element-188">
                The Christmas Palace Team
              </div>
              <div className="text-engage-yellow font-medium text-sm uppercase tracking-wider" data-id="element-189">
                Leadership, The Christmas Palace
              </div>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="mt-20 text-center bg-engage-gray1 border border-engage-gray2 rounded-2xl p-12 md:p-20 relative overflow-hidden" data-id="element-190">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(252,198,13,0.08)_0%,transparent_100%)]" data-id="element-191" />
          <div className="relative z-10 max-w-4xl mx-auto" data-id="element-192">
            <h2 className="text-3xl md:text-5xl font-black mb-6 tracking-tight" data-id="element-193">
              Ready to Build Your Growth Engine?
            </h2>
            <p className="text-engage-gray4 text-xl mb-10" data-id="element-194">
              Stop guessing with your marketing budget. Let's build a
              predictable system for your brand.
            </p>
            <Button to="/contact" variant="primary" className="text-lg px-12 py-5" data-id="element-195">
              Book a Call With Us
            </Button>
          </div>
        </div>
      </div>
    </div>;
}